import React, { useCallback } from "react";
import { Theme } from "@radix-ui/themes";
import { useAdminAuth } from "../hooks/useAdminAuth";
import { useEmployeeData } from "../hooks/useEmployeeData";
import { AdminAuthForm } from "../components/AdminAuthForm";
import { EmployeesView } from "../components/EmployeesView";
import { EmployeesPageContainerProps } from "../types";

export const EmployeesContainer: React.FC<EmployeesPageContainerProps> = () => {
  const {
    isAuthenticated,
    adminSecret,
    verifying,
    error: authError,
    setAdminSecret,
    verifySecret,
  } = useAdminAuth();

  const {
    employees,
    loading,
    error: dataError,
  } = useEmployeeData(isAuthenticated);

  const handleAdminVerification = useCallback(async (e: React.FormEvent) => {
    e.preventDefault();
    await verifySecret();
  }, [verifySecret]);

  const handleSecretChange = useCallback((secret: string) => {
    setAdminSecret(secret);
  }, [setAdminSecret]);

  if (!isAuthenticated) {
    return (
      <Theme>
        <AdminAuthForm
          adminSecret={adminSecret}
          verifying={verifying}
          error={authError}
          onSecretChange={handleSecretChange}
          onSubmit={handleAdminVerification}
        />
      </Theme>
    );
  }

  return (
    <Theme>
      <EmployeesView
        employees={employees}
        loading={loading}
        error={dataError}
      />
    </Theme>
  );
};